import { Check, PencilSimpleLine, X } from "@phosphor-icons/react";

import RestrictedComponent from "common/components/RestrictedComponent";
import { Button } from "common/components/ui/Button";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { Schedule } from "common/types";

import useCampaignSchedule from "../../../../datahooks/useCampaignSchedule";

import type { Dispatch, SetStateAction } from "react";
import type { TimezoneOption } from "../../../../types";

interface ScheduleEditProps {
  isEditing: boolean;
  selectedTimezone: TimezoneOption;
  schedule: Schedule;
  setIsEditing: Dispatch<SetStateAction<boolean>>;
  resetSchedule: () => void;
}

export default function ScheduleEdit({
  isEditing,
  selectedTimezone,
  schedule,
  setIsEditing,
  resetSchedule,
}: ScheduleEditProps) {
  const isDesktop = useTwBreakpoint("lg");
  const { setCampaignSchedule, isSettingCampaignSchedule } =
    useCampaignSchedule();

  function saveEditedSchedule() {
    const { label, offset } = selectedTimezone;

    let newTimezone = null;
    if (offset) {
      newTimezone = {
        name: label,
        offset,
      };
    }

    setCampaignSchedule({
      schedule: {
        ...schedule,
        timezone: newTimezone,
      },
    }).then(() => setIsEditing(false));
  }

  if (isEditing) {
    return (
      <div className="flex gap-2">
        <Button
          variant="outline-black"
          disabled={isSettingCampaignSchedule}
          onClick={resetSchedule}
          intent={isDesktop ? "default" : "iconOnly"}
        >
          {isDesktop ? "Cancel" : <X />}
        </Button>
        <Button
          variant="secondary-purple"
          onClick={saveEditedSchedule}
          isLoading={isSettingCampaignSchedule}
          intent={isDesktop ? "default" : "iconOnly"}
        >
          {isDesktop ? "Save" : <Check />}
        </Button>
      </div>
    );
  }

  return (
    <RestrictedComponent visibleForPermissions={["campaigns_full"]}>
      {isDesktop ? (
        <Button
          variant="secondary-purple"
          leftIcon={<PencilSimpleLine />}
          onClick={() => setIsEditing(true)}
        >
          Edit
        </Button>
      ) : (
        <Button
          intent="iconOnly"
          variant="secondary-black"
          onClick={() => setIsEditing(true)}
        >
          <PencilSimpleLine />
        </Button>
      )}
    </RestrictedComponent>
  );
}
